import type { RequiredGeneric } from '@pba/react-utils';
import cn from 'classnames';
import type { Image } from 'models';
import type { RefObject } from 'react';
import { Avatar } from '../avatar';
import { Col } from '../col';
import { Form, type InputRef } from '../form';
import { Input } from '../input';
import { Row } from '../row';

type P<T extends StringFieldFormValues> = {
  className?: string;
  content: {
    inputName: keyof T & string;
    label: string;
    placeholder: string;
  };
  inputClassName?: string;
  inputRef?: RefObject<InputRef | null>;
  onRequestInput: () => void;
  profilePhoto?: Image;
};

type StringFieldFormValues = Record<string, string | undefined>;

const PlaceholderInput = <T extends StringFieldFormValues = never>({
  className,
  content: { inputName, label, placeholder },
  inputClassName,
  inputRef,
  onRequestInput,
  profilePhoto,
}: RequiredGeneric<T, P<T>>) => (
  <Row className={cn('ui-placeholder-input', className)} gutter={['xs', 'xs']}>
    <Col flex="0 1 0">
      <Avatar size="lg" src={profilePhoto} />
    </Col>
    <Col flex="1 0 0">
      <Form.Item<StringFieldFormValues> className={inputClassName} hideLabel label={label} name={inputName}>
        <Input
          onFocus={() => {
            onRequestInput();
          }}
          placeholder={placeholder}
          ref={inputRef}
        />
      </Form.Item>
    </Col>
  </Row>
);

export default PlaceholderInput;
